module.exports = __webpack_public_path__ + "static/img/01-人大附中西山学校.b098281.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/01-人大附中西山学校.png
// module id = EVso
// module chunks = 0